var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #3e4244;\n      }\n\n      .cls-2, .cls-3 {\n        opacity: .8;\n      }\n\n      .cls-3 {\n        fill: #434749;\n      }\n\n      .cls-4 {\n        fill: #e0b12b;\n      }\n\n      .cls-5 {\n        fill: #777d7f;\n      }\n\n      .cls-6 {\n        fill: #fff4b3;\n      }\n\n      .cls-7 {\n        fill: #798184;\n      }\n\n      .cls-8 {\n        fill: #4b4f51;\n      }\n\n      .cls-9 {\n        fill: #f9d953;\n      }\n\n      .cls-10 {\n        fill: #99a0a3;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_\\u9577\\u65B9\\u5F62_",
    "data-name": "&lt;\\u9577\\u65B9\\u5F62&gt;",
    className: "cls-1",
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_21_\\u91D1\\u9271\\u682A",
    "data-name": "21_\\u91D1\\u9271\\u682A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_21_\\u91D1\\u9271\\u682A_2xPNG_",
    "data-name": "21_\\u91D1\\u9271\\u682A\\uFF082xPNG\\uFF09"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30C8\\u30ED\\u30C3\\u30B3",
    "data-name": "\\u30C8\\u30ED\\u30C3\\u30B3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "16.575 5.304 19.606 4.72 22.527 9.159 17.189 9.301 16.575 5.304"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "22.834 9.537 18.843 9.773 19.824 6.224 19.594 4.703 20.642 6.259 22.834 9.537"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.218,9.395l-2.285.141.273-1.321,2.623-1.99c-.166.404-.61,3.169-.61,3.169Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1-2",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "5.542 9.301 6.331 7.019 8.049 6.529 8.526 5.266 13.096 4.137 14.887 9.655 5.542 9.301"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.327 7.024 10.436 5.753 8.697 7.815 6.327 7.024"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.646 9.867 8.697 7.815 10.411 5.764 12.977 4.103 15.092 9.867 8.646 9.867"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1-3",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "9.937 9.159 11.152 6.259 12.176 5.552 13.122 3.5 16.78 4.42 18.98 9.089 9.937 9.159"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.487 7.745 12.176 7.815 13.25 6.542 16.524 5.764 16.786 4.418 19.274 9.35 9.669 9.867 10.487 7.745"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "16.534 5.76 13.231 9.075 13.237 6.535 16.534 5.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "10.57 7.662 12.195 7.805 11.681 10.197 9.328 10.173 10.57 7.662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u672C\\u4F53",
    "data-name": "\\u672C\\u4F53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "20.445 20.58 7.555 20.58 4.48 10.78 23.52 10.78 20.445 20.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 13.16,
    y: 11.2,
    width: 1.82,
    height: 9.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "9.245 20.58 7.555 20.58 4.48 10.78 6.3 10.78 9.245 20.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.76 20.58 20.45 20.58 23.525 10.78 21.705 10.78 18.76 20.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.096 12.465 19.054 19.723 18.389 19.723 20.502 12.465 21.096 12.465"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u4E0B\\u90E8\\u30D1\\u30FC\\u30C4",
    "data-name": "\\u4E0B\\u90E8\\u30D1\\u30FC\\u30C4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.46,
    y: 19.88,
    width: 17.08,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 5.46,
    y: 19.88,
    width: 17.08,
    height: 1.232
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u8ECA\\u8F2A",
    "data-name": "\\u8ECA\\u8F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 8.96,
    cy: 21.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 8.96,
    cy: 21.7,
    r: 2.044
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.96,
    cy: 21.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 8.96,
    cy: 21.7,
    r: 0.784
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u8ECA\\u8F2A-2",
    "data-name": "\\u8ECA\\u8F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 19.04,
    cy: 21.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 19.04,
    cy: 21.7,
    r: 2.044
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.04,
    cy: 21.7,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 19.04,
    cy: 21.7,
    r: 0.784
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u4E0A\\u90E8\\u30D1\\u30FC\\u30C4",
    "data-name": "\\u4E0A\\u90E8\\u30D1\\u30FC\\u30C4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3.5,
    y: 9.24,
    width: 21,
    height: 2.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22.997 12.469 5.016 12.469 4.792 11.772 23.214 11.772 22.997 12.469"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 3.5,
    y: 9.24,
    width: 21,
    height: 1.68
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdx);
export default __webpack_public_path__ + "static/media/GDX.c43f0ad5beb3dd22c5d842b6f6dbdf17.svg";
export { ForwardRef as ReactComponent };